export enum EChartTimeFormat {
  // Will only show dates when required
  COMPACT = 'compact',
  // Always show dates
  DETAILED = 'detailed',
}

export const DEFAULT_CHART_TIME_FORMAT = EChartTimeFormat.COMPACT;

export type TChartTimeFormatTranslation = Record<EChartTimeFormat, {
  displayName: string,
  details: string,
}>;
